import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { AuthFormStep, DpeDisplayType } from '@as-react/common-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import DpePopupContainer from '../../../containers/DpePopupContainer';
import DpeApi from '../../../api/dpe/DpeApi';
import { Image, ImageSize, Popover, PopoverType, usePopoverHandlers, Button, ButtonSize, ButtonVariant, Group, GroupGutter, GroupVerticalAlign, Text, TextSize, } from '@as/cotopaxi';
const DpeActivator = ({ authFormStep, digitalPartner, logoUrl, displayAs, notAuthLabel, authLabel, isAuthenticated, }) => {
    const { servicesApiPrefixAemServices, DPEPath } = useAemConfig();
    const { t } = useTranslation([I18N_NAMESPACES.buy, I18N_NAMESPACES.dpe]);
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers();
    const [data, setData] = useState();
    const getDpeData = () => __awaiter(void 0, void 0, void 0, function* () {
        const dpeData = yield DpeApi.getPartner(servicesApiPrefixAemServices, digitalPartner, DPEPath);
        setData(dpeData);
    });
    const getPopoverTitle = () => {
        switch (authFormStep) {
            case AuthFormStep.REGISTRATION:
                return isAuthenticated ? (_jsx(Image, { src: data === null || data === void 0 ? void 0 : data.tileData.logo, size: ImageSize.DPE_LOGO_MEDIUM, alt: digitalPartner })) : (_jsx(Image, { src: data === null || data === void 0 ? void 0 : data.authData.logo, size: ImageSize.DPE_LOGO_TITLE, alt: digitalPartner }));
            case AuthFormStep.PASSWORD_FORGOTTEN:
                return t(`${I18N_NAMESPACES.buy}:buy.login.reset.password`);
            case AuthFormStep.LOGIN:
            case AuthFormStep.EMAIL:
            default:
                return _jsx(Image, { src: data === null || data === void 0 ? void 0 : data.tileData.logo, size: ImageSize.DPE_LOGO_MEDIUM, alt: digitalPartner });
        }
    };
    const renderLabel = () => {
        switch (displayAs) {
            case DpeDisplayType.LABEL:
                return (_jsxs(Group, { valign: GroupVerticalAlign.CENTER, gutter: GroupGutter.XSMALL, children: [_jsx(Image, { src: logoUrl, alt: digitalPartner, size: ImageSize.DPE_LOGO_SMALL }), _jsx(Text, { emphasized: true, inline: true, size: TextSize.SMALL, children: t(`${I18N_NAMESPACES.dpe}:dpe.member`) }), _jsx(Button, { onClick: handlePopoverOpen, variant: ButtonVariant.LINK, text: isAuthenticated ? authLabel : notAuthLabel, size: ButtonSize.SMALL }), _jsx(Text, { inline: true, size: TextSize.SMALL, children: t(`${I18N_NAMESPACES.dpe}:dpe.redeemDiscount`) })] }));
            case DpeDisplayType.BUTTON:
            default:
                return (_jsx(Button, { variant: ButtonVariant.BASE, text: isAuthenticated ? authLabel : notAuthLabel, onClick: handlePopoverOpen }));
        }
    };
    useEffect(() => {
        getDpeData();
    }, []);
    return (_jsxs(_Fragment, { children: [renderLabel(), _jsx(Popover, { disableClickOutside: true, type: PopoverType.MODAL, anchorEl: anchorEl, onClose: handlePopoverClose, title: getPopoverTitle(), children: data && (_jsx(DpePopupContainer, { data: data, digitalPartner: digitalPartner, onCloseClick: handlePopoverClose, isAuthenticated: isAuthenticated })) })] }));
};
export default DpeActivator;
